import * as yup from 'yup';

// Parse HH:MM (24-hour) format to minutes since midnight - ONE FORMAT everywhere
const parseTimeToMinutes = (timeStr) => {
  if (!timeStr) return 0;

  const match = timeStr.match(/^(\d{1,2}):(\d{2})$/);
  if (match) {
    return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
  }

  return 0;
};

export const manageSettingsSchema = yup.object().shape({
  days: yup.array().of(
    yup.object().shape({
      enabled: yup.boolean().required(),
      time: yup.array().when('enabled', {
        is: true,
        then: yup.array().of(
          yup.object().shape({
            startTime: yup.string().required('Start time is required'),
            endTime: yup
              .string()
              .required('End time is required')
              .test(
                'end-after-start',
                'End time must be after start time',
                function (endTime) {
                  const { startTime } = this.parent;
                  if (!startTime || !endTime) return true;
                  return (
                    parseTimeToMinutes(endTime) > parseTimeToMinutes(startTime)
                  );
                }
              ),
          })
        ),
        otherwise: yup.array().of(
          yup.object().shape({
            startTime: yup.string(),
            endTime: yup.string(),
          })
        ),
      }),
    })
  ),
});
